import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 32,
	viewBox: "0 0 22 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.72885 1.97984C9.61477 1.80688 9.57089 1.595 9.62793 1.3961C9.65865 1.23179 9.78151 1.13234 9.92631 1.07613C9.97896 1.05451 10.0316 1.03721 10.0887 1.02856C10.1018 1.02424 10.1106 1.02424 10.1238 1.02424C10.409 0.97235 10.7073 1.01991 10.7073 1.01991C13.0592 1.27935 17.6314 1.78526 19.1145 1.94957C19.9043 2.03605 20.2553 2.4598 20.286 3.08245C20.2817 3.22514 20.2553 3.38513 20.1939 3.56674C19.8824 4.52234 18.8644 7.66587 18.2106 9.69815C17.9034 10.6278 17.5831 11.5834 17.4515 11.9207C17.4515 11.9207 17.4515 11.9207 17.4515 11.925C17.3769 12.0547 17.276 12.1931 17.1531 12.2666C17.1487 12.2666 17.1487 12.2709 17.1443 12.2709C17.0917 12.3012 17.0346 12.3228 16.9776 12.3271C16.9732 12.3271 16.9732 12.3271 16.9688 12.3271C16.7056 12.3574 16.4686 12.2061 16.3282 11.9985C16.3282 11.9985 16.1088 11.6612 15.8938 11.3413C15.6832 11.0213 15.2532 10.9262 14.9241 11.1251C14.1167 11.618 12.7565 12.4439 12.6687 12.4958L11.8833 13.006C11.8745 13.0017 11.8657 12.9973 11.857 12.993C10.2378 12.2277 8.61872 11.471 6.98205 10.7316C6.71001 10.6148 6.44673 10.4765 6.19224 10.3208C4.85394 9.46033 4.62577 7.53183 5.7008 6.373L6.495 5.91466L9.99651 3.56674C10.2905 3.36784 10.3739 2.97435 10.1808 2.676L9.72885 1.97984Z",
			fill: "url(#paint0_linear_490_3631)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2315 20.6034C19.2359 22.9038 18.0775 25.0528 16.1469 26.3413C16.1118 26.3673 16.0767 26.3889 16.0416 26.4105L14.225 27.591L14.1153 27.6688L14.2031 27.5002C15.4361 25.122 15.4053 23.9026 12.3163 22.4627L8.4813 20.6769L5.98461 19.5138C5.76082 19.4273 5.54143 19.3278 5.32643 19.2197C5.25183 19.1851 5.18163 19.1462 5.10703 19.1073C2.79902 17.9701 1 15.6697 1 12.9543C1 10.9393 1.72838 9.11026 3.43965 7.85631L5.29571 6.63695L5.73889 6.35156C5.62919 6.47263 5.52827 6.60235 5.4449 6.74072C5.37469 6.84882 5.31765 6.96557 5.265 7.08664C5.23867 7.1515 5.21234 7.21204 5.1904 7.27689C5.13775 7.43256 5.09826 7.58822 5.07632 7.75253C5.05877 7.8736 5.04999 7.999 5.04999 8.12007C5.04999 8.50923 5.13775 8.89406 5.30449 9.24863C5.50633 9.6767 5.82225 10.0442 6.22155 10.3037C6.47605 10.4593 6.73932 10.5934 7.01136 10.7145C7.49842 10.9177 7.9723 11.1555 8.45058 11.376C8.92886 11.5966 9.39397 11.7998 9.86347 12.0203C10.5392 12.336 11.2105 12.6603 11.8863 12.9759C11.895 12.9802 11.9038 12.9845 11.9126 12.9889L12.0091 13.0321L12.7507 13.378L13.444 13.7023L14.0583 13.9877L14.5673 14.2255L14.949 14.4028L15.1772 14.5066L15.2298 14.5325H15.2342C17.5554 15.6568 19.2315 17.8836 19.2315 20.6034Z",
			fill: "url(#paint1_linear_490_3631)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2388 27.4869L14.151 27.6555L8.80224 31.1363L8.71009 31.1969L8.69693 31.2055L8.6706 31.2228H8.66622C6.5776 32.5978 3.7562 32.0444 2.36086 29.9905C0.965526 27.9323 1.52717 25.1519 3.6114 23.7769C3.64212 23.7553 3.67283 23.738 3.70355 23.7164C3.80447 23.6558 3.90539 23.5953 4.00631 23.5434L4.11601 23.4742L5.38849 22.6656L8.52142 20.668L12.3564 22.4538C15.4411 23.885 15.4718 25.1087 14.2388 27.4869Z",
			fill: "url(#paint2_linear_490_3631)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_490_3631",
				x1: 6.54715,
				y1: 11.2244,
				x2: 19.9403,
				y2: 2.22035,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#009C16"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_490_3631",
				x1: 31.593,
				y1: 27.7397,
				x2: -9.12287,
				y2: 6.99285,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1126,
						stopColor: "#009C16"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_490_3631",
				x1: 16.2131,
				y1: 21.1246,
				x2: .905844,
				y2: 31.0895,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#008D01" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .17,
						stopColor: "#00960E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4245,
						stopColor: "#00AE30"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .91,
						stopColor: "#01D467"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#01DD73"
					})
				]
			})
		] })
	]
});
export default SvgLogo;
